import { useFileUrl } from "../../hooks/useFileInputUploader";
import "./companyLogo.scss";

/** The company's logo, from its stored file key. Nothing at all when it has none. */
const CompanyLogo = ({ fileKey, name }: { fileKey?: string; name?: string }) => {
  const { data: url } = useFileUrl(fileKey);
  if (!url) return null;

  return <img className="company-logo" src={url} alt={name ?? ""} />;
};

export default CompanyLogo;
